<template>
  <div class="landingContentDivMK">
    <main>
      <header id="HeaderLNB" class="flex bg-black justify-between">
        <div class="fl flex w-25 items-center h-100">
          <div class="mh2 mv1 logo-container mw-100">
            <img class="h-100 w-100 db-l dn" src="~@/assets/logo-white.svg" alt="BeatHey Logo">
            <div class="dn-l pv1 isologo-container">
              <img class="w-100 h-100" src="~@/assets/isologo-white.svg" alt="BeatHey Logo">
            </div>
          </div>  
        </div>
        <div class="fl flex min-w-25 justify-end items-center iconColor hamburger">
          <clip-loader :loading="loading" :color="color" :size="size" class="mh2"></clip-loader>
          <div v-if="!loading && !isLoggedIn" class="mr2 h-100 flex items-center">
            <div class="dn login">
              <div class="pr1 pointer ttu db btnLnb">
                <div class="customPositionMK">
                  <a @click="setLanguage('es')" v-show="!isLocale('es')" class="pv2 ph3 f5 pointer w-100 ttu">{{ $t("footer.language.spanish") }}</a>
                  <a @click="setLanguage('en')" v-show="!isLocale('en')" class="pv2 ph3 f5 pointer w-100 ttu">{{ $t("footer.language.english") }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="flex flex-column items-center">
        <div class="flex flex-column items-center centerItem h-100 w-100">
            <h1 class="titleTextMK accent"><span class="MusicMK textColor">{{ $t("landing.music") }}</span> {{ $t("landing.title") }} </h1>
            <p class="TextoMK">{{ $t("landing.subtitle") }}</p>
        </div>
        <div @click="login" class="buttonContainerMK">
          <p class="btnPlanesLeftMK ttu">
            {{ $t("app.signin") }} 
            <span class="ph2 ttl f5 dib-ns dn">{{ $t("app.or") }}</span> 
            {{ $t("app.signup") }}
          </p>
        </div>
        <div class="h-100 w-100">
          <div class="flex flex-column w-100">
            <div class="centerPlanesMK">
              <div>
                <h5 class="PlanesTitleMK">{{ $t("landing.planes.title") }}</h5>
                <p class="PlanesTextMK">{{ $t("landing.planes.leyend") }}</p>
                <div class="clasepruebaMK">  
                  <div class="claseprueba1MK">
                    <div class="bg-PlanesMK">
                      <div class="titleDivMK">
                        <h3 class="listTitleMK"> {{$t("users.userType.musicFan")}} </h3>
                      </div>
                      <div>
                        <ul class="PlanesListMK">
                          <li type="square">{{ $t("landing.planes.fan.text1") }}</li>
                          <li type="square">{{ $t("landing.planes.fan.text2") }}</li>
                          <li type="square">{{ $t("landing.planes.fan.text3") }}</li>
                          <li type="square">{{ $t("landing.planes.fan.text4") }}</li>
                          <li type="square">{{ $t("landing.planes.fan.text5") }}</li>
                          <li type="square">{{ $t("landing.planes.fan.text6") }}</li>
                        </ul>
                        <br />
                        <p v-if="isLocale('es')" class="PlanesPricingMK">{{$t("users.subscription.currency")}} {{ pricing[0].currency_override.ARS }} </p>
                        <p v-if="isLocale('en')" class="PlanesPricingMK">{{$t("users.subscription.currency")}} {{ pricing[0].amount }} </p>
                      </div>
                    </div>
                  </div>
                  <div class="claseprueba1MK">
                    <div class="bg-PlanesMK">
                      <div class="titleDivMK">
                        <h3 class="listTitleMK">{{$t("users.userType.producer")}}</h3>
                      </div>
                      <div>
                        <ul class="PlanesListMK">
                          <li type="none" class="EndTitleMK">{{ $t("landing.planes.artist.header") }}</li>
                          <li type="square">{{ $t("landing.planes.artist.text1") }}</li>
                          <li type="square">{{ $t("landing.planes.artist.text2") }}</li>
                          <li type="square">{{ $t("landing.planes.artist.text3") }}</li>
                        </ul>
                        <br />
                        <p v-if="isLocale('es')" class="PlanesPricingMK">{{$t("users.subscription.currency")}} {{ pricing[0].currency_override.ARS }} </p>
                        <p v-if="isLocale('en')" class="PlanesPricingMK">{{$t("users.subscription.currency")}} {{ pricing[0].amount }} </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-100 claseprueba3MK">
              <home-footer />
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import DirectLinkModal from '@/components/modals/provider/DirectLinkModal.vue'
  import ProviderLink from '@/components/providerLink/ProviderLink.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import HomeFooter from '@/components/home/HomeFooter.vue'
  import LandingNavBar from '@/components/Landing/LandingNavBar.vue'
  import { mapGetters, mapActions } from 'vuex'
  import UserInfo from '@/components/UserInfo.vue'
  import { mixin as onClickOutside } from 'vue-on-click-outside'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  
  export default {
    name: 'landingMK',
    components: {
      ProviderLink,
      DirectLinkModal,
      FontAwesomeIcon,
      HomeFooter,
      LandingNavBar,
      UserInfo,
      ClipLoader
    },
    data () {
      return {
        userFromLandingMK: true,
        loginDropdown: false,
        dropdown: false,
        color: '#808080',
        size: '20px',
        CurrentPage: ''
      }
    },
    mixins: [onClickOutside],
    methods: {
      ...mapActions('translator', [
        'setLanguage'
      ]),
      ...mapActions('user', [
        'logout'
      ]),
      ...mapActions('pricing', [
        'getPricing'
      ]),
      isLocale (lang) {
        return this.language === lang
      },
      login () {
        this.$auth0.loginWithRedirect()
      },
      signup () {
        this.$modal.show('signup-modal')
      },
      dropdownTrigger () {
        this.dropdown = !this.dropdown
      },
      closeDropdown () {
        this.dropdown = false
      },
      loginDropdownTrigger () {
        this.loginDropdown = !this.loginDropdown
      },
      closeLoginDropdown () {
        this.loginDropdown = false
      },
      goToHome () {
        this.$router.push({path: '/'})
      },
      logoutButton () {
        if (!this.preventLogout || (this.preventLogout && window.confirm(this.$t('app.leaveConfirmation')))) {
          this.closeDropdown()
          this.$auth0.logout()
          this.logout()
        }
      },
      checkUser (route) {
        if (!this.isLoggedIn) {
          this.$modal.show('login-modal')
          // } else if (!this.isProducer) {
          //  this.$toasted.show(this.$t('tracks.newTrack.notProducer'), {type: 'error'})
        } else if (!this.isSubscribed) {
          this.$modal.show('subscription-modal')
        } else {
          this.$router.push(route)
        }
      }
    },
    created () {
      this.CurrentPage = this.$route.name
      localStorage.setItem('userFromLandingMK', this.userFromLandingMK)
      this.getPricing()
    },
    computed: {
      ...mapGetters('user', [
        'isLoggedIn',
        'isSubscribed',
        'isProducer',
        'user',
        'preventLogout'
      ]),
      ...mapGetters('translator', [
        'language'
      ]),
      ...mapGetters('pricing', [
        'pricing'
      ]),
      loading () {
        return this.$loading.isLoading('user login') || this.$loading.isLoading('user checkUser')
      }
    }
  }
</script>

<style lang="scss">
  @import '~@/variables.scss';

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Bold.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.svg#TitilliumWeb-Bold') format('svg');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Regular.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.svg#TitilliumWeb-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Humnst777-Blk-BT-Black-Italic';
    src: url('~@/assets/fonts/Humnst777-Blk-BT-Black-Italic.ttf') format('truetype');
  }

  @media screen and (max-width: 960px) {
    div.subs-container {
      display: block !important;
    }
    a.mobile-subs {
      display: block !important;
      font-size: 9px;
      font-weight: bold;
      margin-left: -0.8em;
    }
  }

  .hamburger {
    padding-right: 10px;
  }

  .customPositionMK{
    position: relative;
    top: 10px;
  }

  .btnLnb{
    height: 40px;
    width: 195px;
    border-radius: 35px 35px 35px 35px;
    outline: 0;
    border-width: 1px;
    border-color: #E6007E;
    background-color: #E6007E;
    color: #fff;
    outline-offset: 1px;
    text-decoration: none;
    overflow: hidden;
    text-align: center;
  }
  .btnLnb:hover{
    background-color: #fff !important;
    color: #E6007E !important ;
  }

  .btnLnbMobile{
    display: none;
    height: 40px;
    width: 105px;
    border-radius: 35px 35px 35px 35px;
    outline: 0;
    border-width: 1px;
    border-color: #E6007E;
    background-color: #E6007E;
    color: #fff;
    outline-offset: 1px;
    text-decoration: none;
    overflow: hidden;
    text-align: center;
  }
  .btnLnbMobile:hover{
    background-color: #fff !important;
    color: #E6007E !important ;
  }

  .mobile-subs {
    display: none;
  }
  .subs-container {
    margin: 0;
  }
  .header {
    height: $navigation-height;
  }

  #LNB, #LNB:active{
    color: $text-color;
    text-decoration: none;
    background-color: $secondary-color;
  }

  #HeaderLNB{
    position: fixed;
    z-index: 50;
    width: 100%;
  }

  .router-link-active, .link-primary:hover {
    .iconColor {
      color: #aaa
    }
    background-color: $background-color;
    color: $text-color ;
    transition: .3s;
  }

  .iconColor{
    color: $text-color;
  }

  .textColor{
    color: $text-color;
  }

  .router-link-active .white {
    color: white;
  }

  .isologo-container {
    height: $navigation-height;
    width: $navigation-height;
    max-width: $navigation-height;
    min-width: $navigation-height;
    max-height: $navigation-height;
    min-height: $navigation-height;
  }

  .logo-container {
    max-height: 100%;
    max-width: 160px;
  }

  .dropdown-content {
    right: 0;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    z-index: 10;
    background-color: $primary-color;
    color: $text-color;
  }

  .dropdown-content a {
    background-color: $primary-color;
    color: $text-color;
  }

  .dropdown-content a:hover {
    background-color: $background-color;
    color: $text-color !important;
    transition: .3s;
  }

  .dropdown-content button:hover {
    background-color: $background-color
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .mw-50 {
    max-width: 50%;
  }

  .min-w-25 {
    min-width: 25%;
  }

  @media screen and (min-width: 1125px) {
    .login {
      display: flex;
    }
    .login-dropdown {
      display: none;
    }
  }

  @media screen and (max-width: 1100px) {
    .btnLnbMobile{
      display: block;
    }
  }

  .clasepruebaMK{
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 100%;
    width: 100%;
  }

  .claseprueba1MK{
    flex-wrap: wrap;
    width: 25vw;
    height: 63vh;
  }

  .landingContentDivMK{
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #aaa;
    background-color: #393839;
    height: calc(100vh - 3em - 58px);
  }
  .centerPlanesMK{
    background-color: black;
    background-position: center;
    background-size: cover;
    margin-top: 48px;
    margin-bottom: 20px;
    padding-bottom: 75px;
  }
  .PlanesTitleMK{
    font-size: 60px;
    margin-bottom: auto;
    text-align: center;
  }

  .PlanesTextMK{
    font-size: 35px;
    text-align: center;
    margin-left: 60px;
    margin-right: 60px;
  }

  .PlanesPricingMK{
    font-size: 45px;
    text-align: center;
    color: black;
  }

  .bg-PlanesMK{
    background-color: #b2b2b2;
    height: 100%;
    width: 100%;
    border-radius: 15px 15px 15px 15px;
  }
  .PlanesWidthMK{
    width: 56.7%;
    margin-top: 50px;
  }
  .PlanesListMK{
    margin: 45px 15px 45px 0px;
    color:black;
    font-size: 20px;
    text-align: left;
    height: 200px;
  }
  .titleDivMK{
    border-bottom-style: solid;
    border-color: black;
    margin-left: 15px;
    margin-right: 15px;
    text-align: center;
  }
  .listTitleMK{
    font-size: 25px;
    color: black;
    text-align: center;
    padding: 10px;
    margin: auto;
  }
  .rockIcone{
    max-width: 5%;
  }
  .EndTitleMK{
    font-size: 25px;
    color: black;
    justify-content: center;
    margin-bottom: 15px;
  }
  .buttonContainerMK{
    margin-top: 30px;
    margin-bottom: 30px;
    margin: auto;
  }
  .btnPlanesLeftMK{
    padding-bottom: 10px;
    padding-top: 13px;
    font-size: 20px;
      width: 250px;
      height: 50px;
      border-radius: 35px 35px 35px 35px;
      outline: 0;
      border-width: 1px;
      border-color: #E6007E;
      background-color: #E6007E;
      color: #fff;
      outline-offset: 1px;
      text-decoration: none;
      overflow: hidden;
      text-align: center;
  }
  .btnPlanesLeftMK:hover{
    background-color: #fff !important;
    color: #E6007E !important;
  }

  @media screen and (min-width: 1000px) and (max-width:1400px) {
    .PlanesPricingMK{
      font-size: 25px;
      text-align: center;
    }

    .PlanesListMK{
      margin: 45px 15px 25px 0px;
      color:black;
      font-size: 20px;
      text-align: left;
      height: 200px;
    }

    .claseprueba1MK{
      flex-wrap: wrap;
      width: 25vw;
      height: 67vh;
    }
  }

  @media screen and (max-width:700px) {
    .clasepruebaMK{
      margin-top: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      height: 100%;
      width: 100%;
    }

    .claseprueba1MK{
      margin-top: 15px;
      flex-wrap: wrap;
      width: 80%;
    }

    .claseprueba3MK{
      display: flex;
      margin-top: 20px;
      flex-wrap: wrap;
    }

    .PlanesTitleMK{
      font-size: 50px;
      margin-bottom: auto;
      text-align: center;
    }

    .PlanesTextMK{
      font-size: 25px;
      text-align: center;
      margin-left: 60px;
      margin-right: 60px;
    }

    .PlanesPricingMK{
      font-size: 35px;
      text-align: center;
    }
  }

  .VueCarousel-navigation-button{
    color: $text-color !important;
  }


  .landingContentDivMK{
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #aaa;
    background-color: #393839;
    height: calc(100vh - 3em - 58px);
  }
  .TextoMK{
    text-align: center;
    font-size: 35px;
    margin-bottom: 75px;
    margin-top: 25px;
  }

  .MusicMK{
    font-size: 180px;
    font-family: 'Humnst777-Blk-BT-Black-Italic';
    font-style: italic;
    font-weight: normal; 
    text-align: center;
  }
  .titleTextMK{
    font-size: 130px;
    font-family: 'Humnst777-Blk-BT-Black-Italic';
    font-style: italic;
    font-weight: bold;
    text-align: center;
    
  }
  .centerItemMK{
    width: 100%;
    height: 100%;
    background-color: black;
    margin-top: 48px;
  }
  .buttonContainerLandingMK{
    margin-top: 30px;
    margin-bottom: 70px;
  }

  .btnPildoraLeftMK{
    padding-bottom: 10px;
    padding-top: 10px;
    font-size: 35px;
      width: 180px;
      height: 20%;
      border-radius: 35px 0px 0px 35px;
      margin-right: -3px;
      outline: 0;
      border-width: 1px;
      border-color: #E6007E;
      background-color: #E6007E;
      color: #fff;
      outline-offset: 1px;
      text-decoration: none;
      overflow: hidden;
      text-align: center;
  }
  .btnPildoraLeftMK:active,.btnPildoraLeftMK:hover{
    background-color: #fff !important;
    color: #E6007E !important;
  }

  .btnPildoraRigthMK{
    padding-bottom: 10px;
    padding-top: 10px;
    font-size: 35px;
      width: 180px;
      height: 20%;
      border-radius: 0px 35px 35px 0px;
      margin-left: -3px;
      outline: 0;
      border-width: 1px;
      border-color: #E6007E;
      background-color: #E6007E;
      color: #fff ;
      text-decoration: none;
      text-align: center;
      box-shadow: inset 2px 0px 0px 0px #fff;
  }
  .btnPildoraRigthMK:active,.btnPildoraRigthMK:hover{
    background-color: #fff !important;
    color: #E6007E !important;
  }

  @media screen and (max-width:1150px) {
    .MusicMK{
      font-size: 100px;
      font-family: 'Humnst777-Blk-BT-Black-Italic';
      font-style: italic;
      font-weight: normal; 
      text-align: center;
    }
    .titleTextMK{
      font-size: 75px;
      font-family: 'Humnst777-Blk-BT-Black-Italic';
      font-style: italic;
      font-weight: bold;
      text-align: center;
      
    }
  }

  @media screen and (max-width:700px) {
    .MusicMK{
      font-size: 50px;
      font-family: 'Humnst777-Blk-BT-Black-Italic';
      font-style: italic;
      font-weight: normal; 
      text-align: center;
    }
    .titleTextMK{
      font-size: 35px;
      font-family: 'Humnst777-Blk-BT-Black-Italic';
      font-style: italic;
      font-weight: bold;
      text-align: center;
      
    }
    .TextoMK{
      text-align: center;
      font-size: 25px;
      margin-bottom: 75px;
      margin-top: 25px;
    }
  }

  html {
    height: 100%;
  }

  body {
    margin: 0;
    background-color: $background-color;
    height: 100%;
  }

  a, button, input, select, textarea {
    font-family: 'Titillium Web';
  }

  #app-wrapper {
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $text-color;
    background-color: $background-color;
    height: $main-height;
    width: 100vw;
  }

  .main {
    height: $main-height;
    width: 100vw;
  }

  ul {
    margin: 0;
  }

  .bg-primary {
    background-color: $primary-color;
  }

  .bg-secondary {
    background-color: $secondary-color;
  }

  .bg-accent {
    background-color: $accent-color;
  }

  .bg-tertiary{
    background-color: $background-color;
  }

  .primary {
    color: $primary-color;
  }

  .secondary {
    color: $secondary-color;
  }

  .textColor {
    color: $text-color;
  }

  .iconColor {
    color: $icon-color;
  }

  .accent {
    color: $accent-color;
  }
  
  .errorText { 
    color: $error-color;
  }

  .btn {
    border: 0;
    box-sizing: border-box;
    line-height: 2;
    background-color: $primary-color;
    color: white;
  }

  .input {
    box-sizing: border-box;
    line-height: 2;
    border: 0;
    border-bottom: 1px solid #DDDEDF;
    background-color: $background-color;
    color: $text-color !important;
  }

  .error {
    border-bottom: 1px solid $error-color;
  }

  .total-height {
    height: $main-height
  }

  .background-center {
    background-position: center center;
  }

  .text-ellipsis {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .vinyl-rotation {
    animation: 1.5s linear infinite rotation;
  }

  #style-scroll-bar::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 8px;
    background-color:  #555555;
  }

  #style-scroll-bar::-webkit-scrollbar
  {
    width: 8px;
    background-color: #555555;
  }

  #style-scroll-bar::-webkit-scrollbar-thumb
  {
    border-radius: 8px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: $secondary-color;
  }
  @keyframes rotation {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .w-35 {
    width: 35%;
  }

  .w-15 {
    width: 15%;
  }

  .w-7 {
    width: 7%;
  }

  .w-3 {
    width: 3%;
  }

  .w-5 {
    width: 5%;
  }

  .w-95 {
    width: 95%;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                     supported by Chrome and Opera */
  }

  ::placeholder {
    color: $text-color !important;
  }

  .v--modal {
    background-color: $background-color !important;
    color: #aaa !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/landingMK/LandingMK.vue